module.exports = __webpack_public_path__ + "img/file-search.11ed7928.svg";